
import { UserDto, PermissionTypeDto, UserPermissionDto } from "../../../dto/Dtos";
import { CarehomeDto } from "../../../dto/CarehomeDto";

import Dal from './../../../scripts/dataaccess'

import { IFormElementController, FormElementController, FormPageValidator, FormElementValidator, StringValidators } from './../../../scripts/formcontrols'

export class CarehomeUserFormController extends FormPageValidator {

    public _carehome: CarehomeDto;
    private id: string;

    public firstName: FormElementController<string>;
    public email: FormElementController<string>;
    public lastName: FormElementController<string>;
    public permissionType: FormElementController<PermissionTypeDto>;
    public isNewUser: boolean = true;

    constructor() {
        super();

        var firstNameValidator = new FormElementValidator<string>(true);
        var lastNameValidator = new FormElementValidator<string>(true);
        var emailValidator = new FormElementValidator<string>(true);

        this.addValidators(emailValidator, firstNameValidator, lastNameValidator);

        this.firstName = new FormElementController<string>("First Name", "", firstNameValidator);
        this.email = new FormElementController<string>("Email", "", emailValidator);
        this.lastName = new FormElementController<string>("Last Name", "", lastNameValidator);
        this.permissionType = new FormElementController<PermissionTypeDto>("Permission", new PermissionTypeDto(0, ""));
    }

    public load(carehome: CarehomeDto, user: UserDto) {
        this._carehome = carehome;
        this.isNewUser = true;
        if (user && user.email != null && user.email != "") {

            this.isNewUser = false;
            this.id = user.id;
            this.firstName.value = user.firstName;
            this.lastName.value = user.lastName;
            this.email.value = user.email;
            var carehomePermissionId = -1;
            for (var permission of user.userPermissions) {
                if (permission.carehomeId == this._carehome.id) {
                    //this.permissionType.value = permission.permissionId;
                    carehomePermissionId = permission.permissionId;
                }
            }
            //this.permissionType.value = 1;
            var dal = new Dal();
            dal.GetPermissionTypes().then(types => {
                for (var type of types) {
                    if (carehomePermissionId == type.permissionId) {
                        this.permissionType.value = type;
                        console.log("Setting Permission to ", type);
                        break;
                    }
                }
            });
        }
    }

    public GetDto(): UserDto {
        var dto = new UserDto();
        dto.id = this.id;

        dto.email = this.email.value;
        dto.firstName = this.firstName.value;
        dto.lastName = this.lastName.value;

        dto.userPermissions = new Array<UserPermissionDto>();
        var permission = new UserPermissionDto();

        permission.carehomeId = this._carehome.id;
        permission.unitId = this._carehome.unitId;
        permission.permissionId = this.permissionType.value.permissionId;

        dto.userPermissions.push(permission);

        return dto;
    }



        
    public async Submit(): Promise<boolean> {
        var postData = this.GetDto();
        var dal = new Dal();
        if (this.isNewUser) {
            return dal.CreateUser(postData);
        }
        else {
            //return await dal.UpdateUser(postData);
        return new Promise<boolean>(function (resolve) {
            setTimeout(resolve, 1000)
        });
        }

    }

}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/CarehomeUserEditForm/CarehomeUserFormController.ts